<template>
  <div>
    <b-alert
      show
      class="p-1 d-flex align-items-center"
      variant="primary"
    >
      <feather-icon
        icon="AlertCircleIcon"
        class="mr-1"
        size="20"
      />
      <span>You can add a testing device number in order to receive test notifications.</span>
    </b-alert>
    <v-select
      v-model="userType"
      placeholder="Select user type"
      label="User type"
      :options="userTypes"
      class="mb-2"
      :clearable="false"
    />
    <DriversSearch
      v-if="userType == 'driver'"
      :auto-reset="false"
      :filterable="false"
      @drivers-selection="selectedExternalId = $event.externalId"
    />
    <UsersSearch
      v-if="userType == 'user'"
      :auto-reset="false"
      :filterable="false"
      @users-selection="selectedExternalId = $event.externalId"
    />
    <small
      v-if="showErrorMessage"
      class="text-danger"
    >Please select a {{ userType }}</small> <br>
    <b-button
      variant="outline-primary"
      class="mt-2"
      :disabled="loadingTestBtn"
      @click="addDeviceHandler"
    >
      <b-spinner
        v-if="loadingTestBtn"
        small
      />
      <span v-else>Add Device</span>
    </b-button>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { BButton, BAlert, BSpinner } from 'bootstrap-vue'
import DriversSearch from '@/views/driver/components/DriversSearch.vue'
import UsersSearch from '@/views/users/rider/components/UsersSearch.vue'
import useAddDevice from '../hooks/useAddDevice'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import notificationsStore from '../store'

export default {
  components: {
    DriversSearch,
    UsersSearch,
    vSelect,
    BButton,
    BAlert,
    BSpinner,
  },

  setup(_, ctx) {
    useRegisterStoreModule('notifications', notificationsStore)

    return {
      ...useAddDevice(ctx),
    }
  },
}
</script>

<style>

</style>
